import {getJson, postJson, patchJson} from '@/util/ajaxUtils';
import {API_ROOT} from '@/env';
import {getTokens} from '@/util/TokenStore';

export const getHrTemplates = (appId, params = {}) =>
    getJson(`/app/${appId}/hr/template`, {params});

export const createHrTemplate = (appId, data) => postJson(`/app/${appId}/hr/template`, {data});

export const updateHrTemplate = (appId, id, data) =>
    patchJson(`/app/${appId}/hr/template/${id}`, {data});

export const toggleHrTemplate = (appId, id, enabled) =>
    postJson(`/app/${appId}/hr/template/${id}/toggle`, {params: {enabled}});

export const deleteHrTemplate = (appId, id) =>
    import('@/util/ajaxUtils').then(({deleteJson}) =>
        deleteJson(`/app/${appId}/hr/template/${id}`)
    );

export const uploadHrTemplateCover = (appId, file) => {
    const data = new FormData();
    data.append('file', file);
    return postJson(`/app/${appId}/hr/template/cover-upload`, {
        data,
        headers: {'Content-Type': 'multipart/form-data'},
    });
};

export const getHrTemplateCover = async (appId, id) => {
    const {access_token} = getTokens() || {};
    const response = await fetch(`${API_ROOT}/app/${appId}/hr/template/${id}/cover`, {
        headers: access_token ? {Authorization: `Bearer ${access_token}`} : {},
    });
    if (!response.ok) {
        throw new Error('封面素材读取失败');
    }
    return response.blob();
};
